export var props = {
  list: {
    type: Array,
    required: true,
    default: () => []
  },
  sizeOfRow: {
    type: Number,
    required: false,
    default: 1
  }
};